// Page « Quand envoyer les faire-part de mariage » (référencement). En français :
// elle vise « quand envoyer faire part mariage » et « quand envoyer save the date ».
// Délais alignés sur le rétroplanning de l'app (save the date 10 à 4 mois avant,
// commande des faire-part 7 à 5 mois, envoi 6 à 4,5 mois).

import { FaqItem } from '../common/GuideLayout';

export const UPDATED = '2026-10-15';
export const READING_MINUTES = 6;

export const TOC = [
  { id: 'reponse', label: 'La réponse courte' },
  { id: 'calendrier', label: 'Le calendrier complet' },
  { id: 'save-the-date', label: 'Quand envoyer les save the date ?' },
  { id: 'cas', label: 'Les cas où il faut s’y prendre plus tôt' },
  { id: 'contenu', label: 'Ce qu’il faut mettre sur le faire-part' },
  { id: 'faq', label: 'Questions fréquentes' },
];

export const TIMELINE: Array<[string, string, string]> = [
  ['6 à 10 mois avant', 'Envoyer les save the date', 'Pour que vos invités bloquent la date.'],
  ['5 à 7 mois avant', 'Commander les faire-part', 'Création, épreuves, impression : comptez plusieurs semaines.'],
  ['4 à 6 mois avant', 'Envoyer les faire-part', 'Avec une date limite de réponse.'],
  ['4 à 6 semaines avant', 'Date limite de réponse', 'Le temps de relancer avant de donner vos chiffres au traiteur.'],
  ['2 à 3 semaines avant', 'Donner les chiffres au traiteur', 'Nombre de couverts, menus, allergies.'],
];

export const EARLIER = [
  {
    title: 'Mariage à l’étranger ou loin de chez vos invités',
    text: 'Billets, congés, hébergement : envoyez les save the date 10 à 12 mois avant, et les faire-part au moins 6 mois avant.',
  },
  {
    title: 'Mariage en plein été ou sur un pont',
    text: 'Les week-ends de mai, juin et juillet se remplissent vite : prévenez tôt, avant que vos invités ne partent en vacances.',
  },
  {
    title: 'Beaucoup d’invités qui viennent de loin',
    text: 'Plus le voyage est long, plus vos invités ont besoin de temps pour s’organiser.',
  },
  {
    title: 'Un mariage organisé en peu de temps',
    text: 'Pas le temps des save the date ? Un faire-part ou un message avec le lien de votre site, dès que le lieu est confirmé.',
  },
];

export const MUST_HAVE = [
  'Vos prénoms, et souvent ceux de vos parents dans les faire-part traditionnels.',
  'La date, l’heure et le lieu de chaque moment auquel l’invité est convié.',
  'La date limite de réponse et la façon de répondre : adresse de votre site ou QR code.',
  'Les informations pratiques, ou l’adresse de votre site où les retrouver : accès, hébergement, liste de mariage.',
];

export const FAQ: FaqItem[] = [
  {
    q: 'Quand envoyer les faire-part de mariage ?',
    a: '4 à 6 mois avant le mariage, avec une date limite de réponse 4 à 6 semaines avant le jour J. Pour un mariage à l’étranger ou en plein été, prévoyez au moins 6 mois.',
  },
  {
    q: 'Quand envoyer les save the date ?',
    a: '6 à 10 mois avant le mariage, dès que la date et le lieu sont confirmés. Pour un mariage à l’étranger, 10 à 12 mois avant.',
  },
  {
    q: 'Les save the date sont-ils obligatoires ?',
    a: 'Non. Ils sont surtout utiles pour un mariage en saison, à l’étranger, ou avec des invités qui viennent de loin. Sinon, un faire-part envoyé 5 à 6 mois avant suffit.',
  },
  {
    q: 'Quand commander les faire-part ?',
    a: 'Environ un à deux mois avant la date d’envoi, soit 5 à 7 mois avant le mariage : création, épreuves et impression prennent plusieurs semaines.',
  },
  {
    q: 'Quelle date limite de réponse indiquer sur le faire-part ?',
    a: '4 à 6 semaines avant le mariage. Votre traiteur aura besoin du nombre de couverts environ deux à trois semaines avant.',
  },
  {
    q: 'Peut-on envoyer le faire-part par message ?',
    a: 'Oui, de plus en plus de couples envoient un faire-part numérique, ou le lien de leur site d’invitation, en complément ou à la place du papier. Pensez aux invités moins connectés.',
  },
];
